import React from "react";
import { ModalContent, ModalWrapper } from "src/components/dca/GenericModal";
import { ModalHeader } from "../dca/GenericModal";
import { IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import { ArrowBackIos, Close } from "@mui/icons-material";
import {
  setTwoFAModalOpen,
  setUnstakeModalOpen,
  setUnstakeStage,
  useStakingState,
} from "src/store/features/staking.slice";
import { useDispatch } from "react-redux";
import {
  InfoContentStyle,
  SmallSpanRoobertMediumDark,
  StyledStakedspan,
  StyledTableDataLabel,
} from "./staking-styled-components";
import { Formik } from "formik";
import { Form } from "formik";
import { Field } from "formik";
import { StyledSelectbuyorsellspan } from "./staking-styled-components";
import { StyledTextField } from "src/components/application/styled-components/AddressFields";
import { mockCoins } from "./mock";
import StyledButton from "../dashboard/StyledButton";
import { MenuItem } from "@mui/material";
import { GridCheckCircleIcon } from "@mui/x-data-grid";

export const UnstakeModal = () => {
  const { unstakeModalOpen } = useStakingState();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { unstakeStage } = useStakingState();

  return (
    <ModalWrapper open={unstakeModalOpen} onClose={() => dispatch(setUnstakeModalOpen(false))}>
      <ModalHeader>
        {/* If mobile back button */}
        {isMobile && (
          <IconButton
            onClick={() => {
              if (unstakeStage === "info") {
                dispatch(setUnstakeModalOpen(false));
              }
              if (unstakeStage === "unstake") {
                dispatch(setUnstakeStage("info"));
              }
              if (unstakeStage === "review") {
                dispatch(setUnstakeStage("unstake"));
              }
              if (unstakeStage === "submitted") {
                dispatch(setUnstakeModalOpen(false));
              }
            }}
            sx={{ color: "white", position: "absolute", left: "16px" }}>
            <ArrowBackIos />
          </IconButton>
        )}
        <Typography fontSize={"23px"} color={"white"} fontWeight={600}>
          Unstake
        </Typography>
        {/* Close Button */}
        <IconButton
          onClick={() => dispatch(setUnstakeModalOpen(false))}
          sx={{ color: "white", position: "absolute", right: "16px" }}>
          <Close />
        </IconButton>
      </ModalHeader>

      <ModalContent>
        <Stack direction={"column"} gap={2} width={"100%"} textAlign={"left"}>
          {/* Info stage */}
          {unstakeStage === "info" && (
            <div style={{ width: "100%" }}>
              <InfoContentStyle style={{ marginBottom: "18px" }}>
                <SmallSpanRoobertMediumDark
                  style={{ fontWeight: 600, textDecoration: "underline", fontSize: "16px" }}>
                  Important:
                </SmallSpanRoobertMediumDark>
                <SmallSpanRoobertMediumDark style={{ fontWeight: 400, fontSize: "14px" }}>
                  Please be aware that the exit queue period could take a few minutes to several
                  weeks, depending on the asset.
                </SmallSpanRoobertMediumDark>
              </InfoContentStyle>
              <Formik initialValues={{ coin: "Ethereum", amountToUnstake: 0 }} onSubmit={() => {}}>
                <Form>
                  <Stack gap={2}>
                    {/* Coin Field */}
                    <Stack direction={"column"} gap={1}>
                      <StyledSelectbuyorsellspan>Coin</StyledSelectbuyorsellspan>
                      <Field select name="coin" as={StyledTextField} placeholder="Select coin">
                        {mockCoins.map((item, it) => (
                          <MenuItem key={item.label + it} value={item.label}>
                            <Stack direction={"row"} gap={1} alignItems={"center"}>
                              <span style={{ display: "flex" }}>{item.icon}</span>
                              <Typography>{item.label}</Typography>
                            </Stack>
                          </MenuItem>
                        ))}
                      </Field>
                    </Stack>

                    {/* Amount to unstake Field */}
                    <Stack direction={"column"} gap={1} mb={1}>
                      <StyledSelectbuyorsellspan>Amount to unstake</StyledSelectbuyorsellspan>
                      <Field
                        name="amountToUnstake"
                        as={StyledTextField}
                        type="number"
                        placeholder="Enter amount"
                      />
                      <StyledSelectbuyorsellspan style={{ fontSize: "12px" }}>
                        This amount is defaulted to your maximum staked balance.
                      </StyledSelectbuyorsellspan>
                    </Stack>

                    {/* Unstake button */}
                    <StyledButton onClick={() => dispatch(setUnstakeStage("review"))}>
                      Unstake
                    </StyledButton>
                  </Stack>
                </Form>
              </Formik>
            </div>
          )}
          {/* Review stage */}
          {unstakeStage === "review" && (
            <Stack direction={"column"} gap={2} width={"100%"} textAlign={"left"}>
              <Stack direction={"column"}>
                <StyledTableDataLabel style={{ fontWeight: 400 }}>Coin</StyledTableDataLabel>
                <StyledStakedspan>Ethereum</StyledStakedspan>
              </Stack>
              <Stack direction={"column"}>
                <StyledTableDataLabel style={{ fontWeight: 400 }}>APY</StyledTableDataLabel>
                <StyledStakedspan>2-3%</StyledStakedspan>
              </Stack>
              <Stack direction={"column"}>
                <StyledTableDataLabel style={{ fontWeight: 400 }}>
                  Amount to unstake
                </StyledTableDataLabel>
                <StyledStakedspan>32 ETH</StyledStakedspan>
              </Stack>
              {/* If pressed in the review stage start 2FA authentication process */}
              <StyledButton onClick={() => dispatch(setTwoFAModalOpen(true))}>Unstake</StyledButton>
            </Stack>
          )}
          {/* Completed stage */}
          {unstakeStage === "submitted" && (
            <>
              {" "}
              <InfoContentStyle style={{ background: "#F0FEF9" }}>
                {/* Completed icon */}
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                  <GridCheckCircleIcon sx={{ fontSize: "16px", color: "#002035" }} />
                  <SmallSpanRoobertMediumDark style={{ fontWeight: 600, fontSize: "14px" }}>
                    Request to unstake submitted
                  </SmallSpanRoobertMediumDark>
                </Stack>
                <SmallSpanRoobertMediumDark style={{ fontWeight: 400, fontSize: "14px" }}>
                  Your request to unstake has been submitted successfully. You will receive a
                  confirmation email shortly. You may track this in your staking page under
                  “history”.
                </SmallSpanRoobertMediumDark>
              </InfoContentStyle>
              {/* coin */}
              <Stack direction={"column"} gap={1}>
                <StyledTableDataLabel>Coin</StyledTableDataLabel>
                <StyledStakedspan>Ethereum</StyledStakedspan>
              </Stack>
              {/* amount to unstake */}
              <Stack direction={"column"} gap={1}>
                <StyledTableDataLabel>Amount to unstake</StyledTableDataLabel>
                <StyledStakedspan>32 ETH</StyledStakedspan>
              </Stack>
              {/* close button */}
              <StyledButton onClick={() => dispatch(setUnstakeModalOpen(false))}>
                Close
              </StyledButton>
            </>
          )}
        </Stack>
      </ModalContent>
    </ModalWrapper>
  );
};
